import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import type { RouteComponentProps } from 'react-router-dom';
import type VideoStore from 'tm3-core/controls/video/store';
interface IProps extends RouteComponentProps<{ videoId: string }> {
  videoStore?: VideoStore;
}
import HoldingScreen from './holding-screen';
import VideoScreen from './video-screen';

@inject('videoStore')
@observer
class VideoAppointment extends Component<IProps> {
  state = {
    videoId: this.props.match.params.videoId
  };

  render() {
    const { joined } = this.props.videoStore;
    return <>{joined ? <VideoScreen /> : <HoldingScreen videoId={this.state.videoId} />}</>;
  }
}

export default VideoAppointment;
